<script lang="ts">
    import translations from 'Assets/i18n';
    import type {Scenario} from 'Generated/RestClient.g';
    
    export let item: Scenario;
</script>
{#if item.sharedWith}
    <p>
        {translations.pages.publication.presentationListView.sharedWith.format(item.sharedWith)}
    </p>
{/if}

<style>
    p {
        font-style: italic;
    }
</style>
